module.exports = __webpack_public_path__ + "img/1459863878.0d02b245.jpg";